import { useState } from "react";

import { Tab } from "@headlessui/react";

import { AccordionContext } from "common/contexts";
import keyExistsOn from "common/lodash/keyExistsOn";

import Accordion from "components/atoms/AccordionBBC";
import Title from "components/atoms/Title";

import TabListNew from "../TabListNew/index";

const AccordionWithTitle = ({ data, multipleOpen, ...props }) => {
  const checkData = data.some(
    (item) => Object.keys(item).length > 0 && keyExistsOn(item, "title")
  );

  return (
    <div {...props}>
      <>
        {checkData ? (
          <>
            {data.map((item, index) =>
              keyExistsOn(item, "title") ? (
                <div key={index} className="mt-6 lg:mt-10">
                  <Title
                    text={item.title}
                    className="text-xl font-semibold leading-9 text-bbc-gray"
                  />
                  <Accordion
                    list={item.data}
                    multipleOpen={multipleOpen}
                    buttonClass={props.buttonClass}
                    panelClass={props.panelClass}
                  />
                </div>
              ) : (
                <Accordion
                  key={index}
                  list={[item]}
                  multipleOpen={multipleOpen}
                  buttonClass={props.buttonClass}
                  panelClass={props.panelClass}
                />
              )
            )}
          </>
        ) : (
          <Accordion list={data} multipleOpen={multipleOpen} />
        )}
      </>
    </div>
  );
};

const FaqsGroup = ({
  data,
  haveTabs,
  defaultActiveKey,
  multipleOpen,
  ...props
}) => {
  const [active, setActive] = useState([defaultActiveKey]);

  return (
    <AccordionContext.Provider value={{ active, setActive }}>
      {haveTabs ? (
        <TabListNew
          data={data.data.map((item) => item.name)}
          activeTab={data.activeTab}
          tabListClass={{
            display: "flex justify-start lg:justify-center lg:flex-wrap",
            length: "w-full",
            padding: "px-1 py-3",
            border: "border-0",
            othersClass: "overflow-x-auto lg:overflow-x-visible",
          }}
          tabClass={{
            margin: "mx-1",
            othersClass: "whitespace-nowrap",
          }}
        >
          <Tab.Panels>
            {data.data.map((item, index) => (
              <Tab.Panel
                className="focus:outline-none focus:outline-0 focus:ring-0"
                as="div"
                key={index}
              >
                <AccordionWithTitle
                  data={item.faqs}
                  multipleOpen={multipleOpen}
                  className="mt-4"
                  buttonClass={props.buttonClass}
                  panelClass={props.panelClass}
                />
              </Tab.Panel>
            ))}
          </Tab.Panels>
        </TabListNew>
      ) : (
        <Accordion
          list={data}
          buttonClass={props.buttonClass}
          panelClass={props.panelClass}
        />
      )}
    </AccordionContext.Provider>
  );
};

export default FaqsGroup;
